var _path, _path2, _path3, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8999 55.2C53.6918 53.9918 52.2575 53.0334 50.679 52.3796C49.1004 51.7257 47.4086 51.3892 45.7 51.3892C43.9914 51.3892 42.2995 51.7257 40.721 52.3796C39.1424 53.0334 37.7082 53.9918 36.5 55.2",
    stroke: "#004057",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3999 47.7C60.2069 45.5069 57.6033 43.7672 54.7379 42.5804C51.8725 41.3935 48.8014 40.7826 45.7 40.7826C42.5985 40.7826 39.5274 41.3935 36.662 42.5804C33.7966 43.7672 31.1931 45.5069 29 47.7",
    stroke: "#004057",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3999 40.7C66.2876 37.5876 62.5927 35.1188 58.5263 33.4344C54.4598 31.75 50.1014 30.8831 45.6999 30.8831C41.2985 30.8831 36.9401 31.75 32.8736 33.4344C28.8072 35.1188 25.1123 37.5876 22 40.7",
    stroke: "#004057",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6289,
    cy: 61.071,
    r: 2,
    fill: "#004057"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.7029,
    cy: 45.7028,
    r: 30.8168,
    transform: "rotate(45 45.7029 45.7028)",
    stroke: "#E11818",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.3239,
    y1: 68.4757,
    x2: 67.3239,
    y2: 25.4757,
    stroke: "#E11818",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.9732150fb7196800b454df4fd2f9f2c3.svg";
export { ForwardRef as ReactComponent };